export default __webpack_public_path__ + "static/media/tour-guild-aa.0ba1e12c.png";